import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'

/******************************

  - 사용법

  dispatch(alertActions.(success, error, confirm 중 택1)({
    title: '성공',
    message: '정상적으로 등록되었습니다.',

    <--- confirm일 경우 --->
    params: {
      type: 'confirm',
      action: 'canvasActions',
      method: 'open',
      params: params,
      callback: function
    }
    <--- confirm일 경우 --->
  }))

******************************/

const Alert = (props) => {
  const { dispatch } = props

  const handle = (type) => {
    const data = props.alert.params?.params

    if (type == 'ok') {
      if (data?.callback) {
        props.alert.type !== 'ERROR' && data.callback()
      } else {
        data && dispatch(actions[data.action][data.method](data.params))
      }
    }

    if (type == 'cancel' && data?.cancelCallback) {
      data.cancelCallback()
    }

    dispatch(actions.alertActions.clear())
  }

  const renderSwitch = (type) => {
    switch (type) {
      case 'SUCCESS':
        return '성공'
      case 'ERROR':
        return '오류'
      case 'CONFIRM':
        return '확인'
      case 'INFO':
        return '확인'
      default:
        return null
    }
  }

  return (
    <React.Fragment>
      {props.alert.isShow ? (
        <div className="alert-wrap">
          <div className="alert-box">
            <p>
              {props.alert.message
                ? props.alert.message.split('\n').map((line, index) => {
                    return (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    )
                  })
                : ''}
            </p>
            <div className="alert-btn">
              {props.alert?.params?.params?.type === 'confirm' ? (
                <button type="button" data-dismiss="modal" aria-label="Close" onClick={() => handle('cancel')}>
                  {props.alert.params?.params?.cancelBtnTitle || '취소'}
                </button>
              ) : (
                ''
              )}
              <button type="button" className="alert-close" onClick={() => handle('ok')}>
                {props.alert.params?.params?.okBtnTitle || '확인'}
              </button>
            </div>

            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => handle('cancel')}
            ></button>
          </div>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (dispatch) => {
  return {
    alert: dispatch.alert,
  }
}

export default connect(mapStateToProps)(Alert)
